module.exports = "<p class=\"amw-not-logged\">\r\n  Please sign in to continue</p>\r\n"